module.exports = "https://static.wmbcdn.com/uniweb/images/f70ab22c68b6c9a2ccdcd020afac94c2.svg";